module.exports = __webpack_public_path__ + "img/logo profile priority-74.d1afbecf.jpg";